<template>
    <div class="w-full virtual-games__wrapper">
        <MaintenanceChecker
            :checkedParts="checkedParts"
            class="w-full"
        >
            <template slot="message">
                <div class="maintenance-mode__offer">
                    <Illustration xl image="/static/img/illustrations/casino__maintenance.svg"/>
                    <div class="maintenance-mode__offer-copy">
                        {{ $t('Virtual games are currently under maintenance') }}
                    </div>
                </div>
            </template>
            <div
                v-if="isLoading"
                class="spinner-container"
            >
                <SpinnerBars/>
            </div>
            <div
                v-else
                class="container"
            >
                <CarouselBannerContainer :banners="virtualBanners"/>
                <GamesGrid>
                    <VirtualGame
                        v-for="(game, index) in games"
                        v-bind="game"
                        :key="index"
                        @click="() => onGameClick(game.redirectUrl)"
                        class="virtual-games"
                    />
                </GamesGrid>
            </div>
        </MaintenanceChecker>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { errorGuard } from '@app/utils';
    import { links } from '@app/router';
    import CarouselBannerContainer from '@modules/shared/banners/CarouselBannerContainer.vue';
    import { BannerCategory } from '@core/models/banners/enums';
    import { MaintenanceType } from '@core/models/country/enums';
    import GamesGrid from '../shared/components/GamesGrid.vue';
    import VirtualGame from '../shared/components/VirtualGame.vue';

    export default {
        name: 'VirtualGamesContainer',
        data() {
            return {
                isLoading: false,
                page: BannerCategory.games,
                checkedParts: [
                    // defined in cms like this
                    MaintenanceType.virtual
                ]
            };
        },
        async created() {
            // this.fetchVirtualBanners();
            this.isLoading = true;
            await errorGuard({
                action: async () => {
                    await this.fetchAllGames();
                },
            });
            this.isLoading = false;
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('data/games', [
                'virtualGames',
            ]),
            ...mapGetters('data/banners', [
                'virtualBanners',
            ]),
            games() {
                return this.virtualGames.filter((game) => !game.test
                    || (game.test && this.user && this.config.testingAccounts.virtualGamesAccounts[this.user.userId]));
            }
        },
        methods: {
            ...mapActions('data/games', [
                'fetchAllGames',
            ]),
            onGameClick(url) {
                this.$router.push(`${links.virtual}/${url}`);
            },
            ...mapActions('data/banners', [
                'fetchVirtualBanners',
            ]),
        },
        components: {
            VirtualGame,
            CarouselBannerContainer,
            GamesGrid,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/games/virtuals/VirtualGamesContainer.vue